import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateFilterItemsEnum } from '../filter.enum';
import { DateFilterItems } from '../filter.constants';
import { Filter } from '../filter.interface';

@Component({
  selector: 'app-filter-date',
  templateUrl: './filter-date.component.html',
  styleUrls: ['./filter-date.component.scss'],
})
export class FilterDateComponent {
  showRange: boolean = false;
  dateFilterItems = DateFilterItems;
  dateFilterItemsEnum = DateFilterItemsEnum;
  fromDate: Date | null;
  toDate: Date | null;
  start: any = null;
  end: any = null;

  @Input() filter: Filter;
  @Input() dateType: 'created' | 'modified';

  @Output() filterEvent: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor() {}

  toggleShowRange(event?: any) {
    if (event) {
      event.stopPropagation();
    }

    this.showRange = !this.showRange;
  }

  clearDate() {
    this.filterEvent.emit({
      ...this.filter,
      [this.dateType]: {
        name: this.dateType,
        value: null,
      },
    });
  }

  public setFilterValue(item: any): void {
    if (item) {
      this.filterEvent.emit({
        ...this.filter,
        [this.dateType]: {
          name: item.name,
          value: item.value,
        },
      });
    }
    // if (item) {
    //   const date = new Date();
    //   const value = item;
    //   if (value === DateFilterItemsEnum.SET_A_RANGE) {
    //     // Set a range

    //     this.start = this.fromDate!.toISOString();
    //     this.end = this.toDate!.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: 'Custom range',
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.All_TIME) {
    //     // All Time

    //     this.end = new Date().toISOString();
    //     const s = new Date(2019, 1, 1, 0, 0, 0, 0);
    //     this.start = s.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.All_TIME,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.TODAY) {
    //     // Today

    //     this.end = new Date().toISOString();
    //     this.start = new Date();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.TODAY,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.YESTERDAY) {
    //     // Yesterday

    //     this.end = new Date().toISOString();
    //     const s = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth(),
    //       new Date().getDate() - 1
    //     );

    //     this.start = s.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.YESTERDAY,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.LAST_7_DAYS) {
    //     // Last 7 Days
    //     this.end = new Date().toISOString();
    //     const s = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth(),
    //       new Date().getDate() - 7
    //     );

    //     this.start = s.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.LAST_7_DAYS,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.LAST_30_DAYS) {
    //     // Last 30 Days
    //     this.end = new Date().toISOString();
    //     const s = new Date(
    //       new Date().getFullYear(),
    //       new Date().getMonth(),
    //       new Date().getDate() - 30
    //     );
    //     this.start = s.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.LAST_30_DAYS,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.THIS_YEAR) {
    //     // This Year
    //     this.end = new Date().toISOString();
    //     const s = new Date(date.getFullYear(), 0, 1);
    //     this.start = s.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.THIS_YEAR,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   } else if (value === DateFilterItemsEnum.LAST_YEAR) {
    //     // Last Year
    //     this.end = new Date().toISOString();
    //     const s = new Date(date.getFullYear() - 1, 0, 1);
    //     this.start = s.toISOString();

    //     this.filterEvent.emit({
    //       ...this.filter,
    //       [this.dateType]: {
    //         name: DateFilterItemsEnum.LAST_YEAR,
    //         value: { start: this.start, end: this.end },
    //       },
    //     });
    //   }
    // }
  }
}
